<script setup lang="ts">
import { inject, reactive, type Ref } from 'vue';
import type { AnalysisCategory, AnalysisType } from '@/services/api/emsl';

interface DialogRefValue {
  data?: { item?: AnalysisType; categories: AnalysisCategory[] };
}

const dialogRef = inject<Ref<DialogRefValue | undefined>>('dialogRef');
const emit = defineEmits<{ (e: 'close', data?: unknown): void }>();

const data = dialogRef?.value?.data;
const categories = data?.categories ?? [];

const form = reactive({
  name: data?.item?.name ?? '',
  analysis_category_id: data?.item?.analysis_category_id ?? null as number | null,
});

function submit(): void {
  if (!form.name || form.analysis_category_id === null) return;
  emit('close', { name: form.name, analysis_category_id: form.analysis_category_id });
}
</script>

<template>
  <form class="at-dialog" @submit.prevent="submit">
    <div class="at-dialog__field">
      <label for="at-name">Name</label>
      <input id="at-name" v-model="form.name" type="text" required autofocus />
    </div>
    <div class="at-dialog__field">
      <label for="at-category">Category</label>
      <select id="at-category" v-model="form.analysis_category_id" required>
        <option :value="null" disabled>Select category</option>
        <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option>
      </select>
    </div>
    <div class="at-dialog__actions">
      <button type="submit">Save</button>
      <button type="button" @click="emit('close')">Cancel</button>
    </div>
  </form>
</template>

<style scoped>
.at-dialog {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.25rem 0 0.5rem;
  min-width: 20rem;
}
.at-dialog__field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}
.at-dialog__field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}
.at-dialog__field input,
.at-dialog__field select {
  padding: 0.4rem 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font: inherit;
}
.at-dialog__actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  padding-top: 0.25rem;
}
</style>
